import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Styles from "./Checkmark.module.scss";

type CheckmarkProps = {
  selected?: boolean;
  name: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string | React.ReactNode;
  withBorder?: boolean;
  checked?: boolean;
  className?: string;
  autoFocus?: boolean;
  error?: string;
  resetError?: () => void;
  id?: string;
};

const Checkmark = ({
  selected,
  name,
  value,
  onChange,
  label,
  withBorder = false,
  className,
  autoFocus,
  error,
  resetError,
}: CheckmarkProps) => {
  const [focus, setFocus] = useState(false);
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [autoFocus]);

  const onCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    resetError && resetError();
    onChange(e);
  };

  return (
    <div
      className={classNames(Styles.checkmark, className, {
        [Styles.withBorder]: withBorder,
        [Styles.focus]: focus,
        [Styles.error]: !!error,
      })}
    >
      <input
        role="checkbox"
        id={`${name}_${String(value)}`}
        type="checkbox"
        name={name}
        value={value}
        onChange={onCheck}
        defaultChecked={selected}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        ref={ref}
      />
      <label className={Styles.basicLabel} htmlFor={`${name}_${String(value)}`}>
        {label}
      </label>
      {/* <span className={Styles.text}></span> */}
    </div>
  );
};

export { Checkmark };
